export default __webpack_public_path__ + "static/media/notif.54a83020.ogg";